module.exports = __webpack_public_path__ + "static/scale-model-of-the-great-escape-room-in-tampa-florida-02adf2a07cfdf16e6516b2a7d2eb4994.png";